import { LBMultipleUsersIcon, LBUserIcon } from '@linearb/buzz'

export const buyerEngagedLabel = (count: number): string =>
  count === 1
    ? '1 buyer engaged with AI Analytics'
    : `${count} buyers engaged with AI Analytics`

interface BuyerChipProps {
  count: number
  withSeparator?: boolean
}

export const BuyerChip = ({ count, withSeparator = false }: BuyerChipProps) => {
  if (count <= 0) {
    return null
  }
  const Icon = count > 1 ? LBMultipleUsersIcon : LBUserIcon
  return (
    <>
      {withSeparator && (
        <span aria-hidden='true' className='opacity-50'>
          |
        </span>
      )}
      <Icon className='h-4 w-4' />
      {count}
    </>
  )
}
